import { REQUEST_A_TEMPLATE_URL } from "@constants/banner";

export const DEFAULT_PUBLIC_SHOP_LONG_DES =
  "Are you looking for a unique and personalized way to celebrate your loved ones? Look no further than our customized gift shop. Our online shop offers a wide range of food, work, play, and swag items, giving recipients the opportunity to select any gift they choose.";

export const DEFAULT_ACCOUNT_SHOP_LONG_DES =
  "Are you looking for a unique and personalized way to celebrate your employees' milestones? Look no further than our customized gift shop. Our online shop offers a wide range of food, work, play, and swag items, giving recipients the opportunity to select any gift they choose.";

export const USER_SHOP_DATA = {
  uTitle: "Customer Case Study",
  uDescription:
    "You’re previewing a live shop created by one of our users. This user might have uploaded their own logo and banner, which isn’t available to duplicate. Not sure where to start? ",
  uPrimaryCtaText: "CREATE SHOP",
  uSecondaryCtaText: "Request a Template.",
  uAnchorLink: REQUEST_A_TEMPLATE_URL,
};
